import { isMemberSignedIn } from '@vista-digital/occ-domain'

export function isSignedIn() {
    return isMemberSignedIn()
}
